const BOTTOM_TABS = {
    HOME: 'HOME',
    SEARCH: 'SEARCH',
    SETTINGS: 'SETTINGS',
} as const;

export default BOTTOM_TABS;
